import { useMemo } from 'react';
import useProfileTheme from './useProfileTheme';
import { createProfileSx } from '../styles/profileLayout';
import { createProfileTableFilters, createProfileTableOverrides } from '../styles/profileTableStyles';

export default function useProfileSx() {
  const tokens = useProfileTheme();
  return useMemo(
    () => ({
      ...createProfileSx(tokens),
      tableOverrides: createProfileTableOverrides(tokens),
      tableFilters: createProfileTableFilters(tokens),
    }),
    [tokens]
  );
}
